import React, { useContext, useState, useEffect } from 'react';
import { AuthContextAdmin } from '../context/AuthContextAdmin';
import { AuthContextPublic } from '../context/AuthContextPublic';
import { firestore } from '../Firebase';
import HelpModal, { parseHelperItems } from './HelpModal';

const HeaderPublic = ({ name, features = {} }) => {
  const { userName, logoutPublic } = useContext(AuthContextPublic) || {};
  const { userAdmin } = useContext(AuthContextAdmin) || {};
  const [helperItems, setHelperItems] = useState([]);
  const [showHelpModal, setShowHelpModal] = useState(false);

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    })
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        })
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const unsubscribe = firestore
      .collection('settings')
      .doc('customization')
      .onSnapshot(
        (doc) => {
          setHelperItems(
            doc.exists ? parseHelperItems(doc.data().helperItems) : []
          );
        },
        (error) => {
          console.error('Error listening to helper items:', error);
        }
      );

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    logoutPublic();
    // Force a full page reload and change URL to root
    window.location.href = '/';
  };

  return (
    <div className="container-fluid">
      <div
        className={`d-inline-flex align-items-center float-end pe-1 ps-2 pt-1 me-1 pb-2 ${
          !features.hasDarkModeOn ? 'bg-white' : 'bg-dark text-white'
        } rounded-3 shadow`}
      >
        <span className="me-3">{currentTime}</span>
        <span className="me-1">
          {userName} {userAdmin ? '(Admin)' : ''}
        </span>
        <i className="fas fa-user-alt me-2"></i>
        {helperItems.length > 0 && (
          <i
            className={`fas fa-question-circle ${
              features.hasDarkModeOn ? 'text-info' : 'text-primary'
            }`}
            onClick={() => setShowHelpModal(true)}
            style={{
              cursor: 'pointer',
              fontSize: '1.2rem',
              padding: '0.25rem 0.5rem',
            }}
            title="Help"
          ></i>
        )}
        <i
          className={`fas fa-sign-out-alt ${
            features.hasDarkModeOn ? 'text-info' : 'text-primary'
          }`}
          onClick={handleLogout}
          style={{
            cursor: 'pointer',
            fontSize: '1.2rem',
            padding: '0.25rem 0.5rem',
          }}
          title="Logout"
        ></i>
      </div>
      <HelpModal
        show={showHelpModal}
        onHide={() => setShowHelpModal(false)}
        helperItems={helperItems}
      />
    </div>
  );
};

export default HeaderPublic;
